import { RiskFeedScreen } from "@civala/investor-nexus-pitch"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/risk-feed")({
  component: RiskFeedScreen,
})
